import type { ImgHTMLAttributes } from 'react';

export const LAZY_IMAGE_LOADING = 'lazy' as const;

export const lazyImgProps: Pick<
  ImgHTMLAttributes<HTMLImageElement>,
  'loading'
> = {
  loading: LAZY_IMAGE_LOADING,
};
